import PropTypes from "prop-types"
import * as React from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

const PasswordInput = React.forwardRef(({
  className,
  toggleTestId = "password-visibility-toggle",
  ...props
}, ref) => {
  const [visible, setVisible] = React.useState(false);

  return (
    <div className="relative">
      <Input
        ref={ref}
        type={visible ? "text" : "password"}
        className={cn("password-input-field pr-10", className)}
        autoCapitalize="off"
        autoCorrect="off"
        spellCheck={false}
        {...props}
      />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        className="absolute right-2 top-1/2 -translate-y-1/2 rounded p-1 text-slate-400 hover:text-slate-600 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-indigo-500"
        aria-label={visible ? "Hide password" : "Show password"}
        data-testid={toggleTestId}
      >
        {visible ? <EyeOff size={16} aria-hidden /> : <Eye size={16} aria-hidden />}
      </button>
    </div>
  );
});
PasswordInput.displayName = "PasswordInput";
PasswordInput.propTypes = {
  className: PropTypes.string,
  toggleTestId: PropTypes.string,
};

export { PasswordInput };
